import sgWinRespinCelebrator from "components/sg-win-respin-celebrator";
import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import smartUiFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";
import backgroundTint from "components/show-win-lines/background-tint";

export class SGRespinCelebration extends State {
    public onExit(): void {
        backgroundTint.hide();
        smartUiFlags.set(SmartUIFlag.NO_SKIP, false);

        Layers.CelebrationContent.defaultScene().execute();
    }

    public onEnter(): void {

        smartUiFlags.set(SmartUIFlag.NO_SKIP, true);

        Layers.CelebrationContent.setScene("winRespin").then(() => {
            Services.sound.customEvent("win_respin");
            sgWinRespinCelebrator.startRespin().then(() => this.complete());
        });
    }
}
